module.exports = __webpack_public_path__ + "static/comparison-f567c6b249218719993cb0e8db16cb3c.svg";